// @flow
import * as React from 'react';
import type { State as Flags } from 'reducers/flags';

type Flag = $Keys<Flags>;

type Props = {|
  +flags: Flags,
  +flag: Flag,
  +negate?: boolean,
  +fallback?: React.Node,
  +children: React.Node,
|};

export default ({ flags, flag, negate, fallback, children }: Props) => {
  if (!(flag in flags)) {
    throw Error(`${flag} not in flags.`);
  }

  let flagValue = flags[flag];

  if (negate) {
    flagValue = !flagValue;
  }

  if (flagValue) {
    return children;
  }

  return fallback || null;
};



// WEBPACK FOOTER //
// ./components/FeatureToggle/FeatureToggle.js